import { fo_monan_chitiet } from "../../../models/response/dich-vu/food/fo_monan_chitiet";
import {
	eFoMonAnChiTietActionTypeIds,
	IFoMonAnChiTietChangeSelectedIds,
	IFoMonAnChiTietCloseConfirm,
	IFoMonAnChiTietCloseDetail,
	IFoMonAnChiTietDeleteErr,
	IFoMonAnChiTietDeleteStart,
	IFoMonAnChiTietDeleteSuccess,
	IFoMonAnChiTietLoadDetailErr,
	IFoMonAnChiTietLoadDetailStart,
	IFoMonAnChiTietLoadDetailSuccess,
	IFoMonAnChiTietLoadErr,
	IFoMonAnChiTietLoadStart,
	IFoMonAnChiTietLoadSuccess,
	IFoMonAnChiTietSaveErr,
	IFoMonAnChiTietSaveStart,
	IFoMonAnChiTietSaveSuccess,
	IFoMonAnChiTietShowConfirm,
	IFoMonAnChiTietShowDetail
} from "../../action-types/dich-vu/IFoMonAnChiTietActionTypes";

export const foMonAnChiTietActions = {
	loadFoMonAnChiTietStart: (dm_coso_id: number): IFoMonAnChiTietLoadStart => {
		return {
			type: eFoMonAnChiTietActionTypeIds.LOAD_START,
			payload: dm_coso_id
		}
	},
	loadFoMonAnChiTietSuccess: (data: fo_monan_chitiet[]): IFoMonAnChiTietLoadSuccess => {
		return {
			type: eFoMonAnChiTietActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadFoMonAnChiTietError: (message: string): IFoMonAnChiTietLoadErr => {
		return {
			type: eFoMonAnChiTietActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	loadFoMonAnChiTietDetailStart: (id: number): IFoMonAnChiTietLoadDetailStart => {
		return {
			type: eFoMonAnChiTietActionTypeIds.LOAD_DETAIL_START,
			payload: id
		}
	},
	loadFoMonAnChiTietDetailSuccess: (data: fo_monan_chitiet): IFoMonAnChiTietLoadDetailSuccess => {
		return {
			type: eFoMonAnChiTietActionTypeIds.LOAD_DETAIL_SUCCESS,
			payload: data
		}
	},
	loadFoMonAnChiTietDetailError: (message: string): IFoMonAnChiTietLoadDetailErr => {
		return {
			type: eFoMonAnChiTietActionTypeIds.LOAD_DETAIL_ERROR,
			payload: message
		}
	},
	showFoMonAnChiTietDetail: (data?: fo_monan_chitiet): IFoMonAnChiTietShowDetail => {
		return {
			type: eFoMonAnChiTietActionTypeIds.SHOW_DETAIL,
			payload: data
		}
	},
	closeFoMonAnChiTietDetail: (): IFoMonAnChiTietCloseDetail => {
		return {
			type: eFoMonAnChiTietActionTypeIds.CLOSE_DETAIL
		}
	},
	changeFoMonAnChiTietSelectedIds: (ids: number[]): IFoMonAnChiTietChangeSelectedIds => {
		return {
			type: eFoMonAnChiTietActionTypeIds.CHANGE_SELECTED_IDS,
			payload: ids
		}
	},
	showFoMonAnChiTietConfirm: (): IFoMonAnChiTietShowConfirm => {
		return {
			type: eFoMonAnChiTietActionTypeIds.SHOW_CONFIRM
		}
	},
	closeFoMonAnChiTietConfirm: (): IFoMonAnChiTietCloseConfirm => {
		return {
			type: eFoMonAnChiTietActionTypeIds.CLOSE_CONFIRM
		}
	},
	saveFoMonAnChiTietStart: (data: fo_monan_chitiet): IFoMonAnChiTietSaveStart => {
		return {
			type: eFoMonAnChiTietActionTypeIds.SAVE_START,
			payload: data
		}
	},
	saveFoMonAnChiTietSuccess: (is_update: boolean): IFoMonAnChiTietSaveSuccess => {
		return {
			type: eFoMonAnChiTietActionTypeIds.SAVE_SUCCESS,
			payload: is_update
		}
	},
	saveFoMonAnChiTietError: (message: string): IFoMonAnChiTietSaveErr => {
		return {
			type: eFoMonAnChiTietActionTypeIds.SAVE_ERROR,
			payload: message
		}
	},
	deleteFoMonAnChiTietStart: (id: number): IFoMonAnChiTietDeleteStart => {
		return {
			type: eFoMonAnChiTietActionTypeIds.DELETE_START,
			payload: id
		}
	},
	deleteFoMonAnChiTietSuccess: (): IFoMonAnChiTietDeleteSuccess => {
		return {
			type: eFoMonAnChiTietActionTypeIds.DELETE_SUCCESS
		}
	},
	deleteFoMonAnChiTietError: (message: string): IFoMonAnChiTietDeleteErr => {
		return {
			type: eFoMonAnChiTietActionTypeIds.DELETE_ERROR,
			payload: message
		}
	}
}
